import { Z_INDEX_NAV_COMPONENT_DEFAULT } from '../../../constants/z_index';
export const getStyle = () => {
  return {
    height: 'min(195px, calc(100% - var(--global-nav-height, 86px) - 32px))',
    transition: 'height 300ms, width 300ms',
    width: '420px',
    position: 'absolute',
    top: 'calc(var(--global-nav-height, 86px) + 16px)',
    right: '16px',
    bottom: 'unset',
    boxShadow: '0px 10px 30px rgba(0,0,0,0.18)',
    borderRadius: '3px',
    overflow: 'hidden',
    animationName: 'in-app-help-fade-in',
    animationDuration: '.5s',
    zIndex: Z_INDEX_NAV_COMPONENT_DEFAULT
  };
};